module.exports = __webpack_public_path__ + "static/media/sk.e6276ae1.svg";